"use strict";

(function () {
  "use strict";

  config.$inject = ["$stateProvider"];
  angular.module("customerCommunications").config(config);

  function config($stateProvider) {
    $stateProvider.state("customerCommunications", {
      url: "/customerCommunications",
      templateUrl: "app/pages/customerCommunications/customerCommunications.html",
      controller: "CustomerCommunicationsCtrl",
      controllerAs: "vm",
      resolve: {
        ready: function ready($q, $rootScope) {
          var deferred = $q.defer();
          if ($rootScope.$user) {
            deferred.resolve("");
          } else {
            $rootScope.$watch(function () {
              return $rootScope.$user;
            }, function () {
              if ($rootScope.$user) {
                deferred.resolve("");
              }
            }, true);
          }
          return deferred.promise;
        }
      }
    });
  }
})();